import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@clouway/ui'

const TYPES = ['vehicle', 'iot', 'mobile'] as const

export function TrackingObjectTypeSelector({
  value,
  onChange,
}: {
  value?: string
  onChange: (value: string) => void
}) {
  const { t } = useTranslation('feature')

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger aria-label={t('trackingObjects.activationForm.type')}>
        <SelectValue placeholder={t('vendor.select.placeholder')} />
      </SelectTrigger>
      <SelectContent>
        {TYPES.map(type => (
          <SelectItem key={type} value={type}>
            {t(`trackingObjects.types.${type}` as 'trackingObjects.types.iot')}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
